import { useCallback, useMemo } from 'react'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import {
  saveFilterPreference,
  selectAllFilterPreferences,
} from '@user/store/userPreferences'
import { ImportFilterSet } from '../filters'
import { setImportFilters } from '../slice'
import { useSelector } from 'react-redux'
import { serializeFilters } from '@user/components/Filters/utils/serializeFilters'
import { IImport } from '../typings'

export const useSaveImportFilters = () => {
  const dispatch = useAppDispatch()

  const prefs = useSelector(selectAllFilterPreferences)

  const importPref = useMemo(
    () => prefs.find((p) => p.type === 'import'),
    [prefs],
  )

  return useCallback(
    (model: ImportFilterSet) => {
      dispatch(
        saveFilterPreference({
          id: importPref?.id,
          type: 'import',
          name: 'import filters',
          filter: serializeFilters<IImport, ImportFilterSet>(model),
        }),
      )
      dispatch(setImportFilters(model))
    },
    [dispatch, importPref?.id],
  )
}
